<template>
  <div id="app" v-loading.fullscreen.lock="loadingMask" element-loading-text="loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <main-header class="my-main-header no-print"></main-header>

    <!-- <div class="my-main-content"> -->
    <router-view v-if="loading" />
    <!-- </div> -->

    <main-footer class="my-main-footer no-print"></main-footer>

    <audio id="success_music" src preload="auto"></audio>
  </div>
</template>

<script>
import MainHeader from "./components/MainHeader.vue";
import MainFooter from "./components/MainFooter.vue";
import { mapState } from "vuex";

export default {
  name: "app",
  components: {
    MainHeader,
    MainFooter
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState(["loadingMask"])
  },
  async created() {
    await this.$getArea();
    await this.$getQRcode();
    this.loading = true;
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    goToTheTop() {
      document.body.scrollTop = 0;
    }
  }
};
</script>

<style>
html,
body {
  /* 設定body高度為100% 拉到視窗可視的大小 */
  height: 100vh;
  padding: 0;
  margin: 0;
  background-color: #333333;
  /* overflow-y: auto; */
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  height: 100vh;
  background-color: #333333;
}

.my-main-header {
  background-color: #4f4f4f;
  position: fixed !important;
  width: 100%;
  z-index: 5;
  height: 60px;
  color: white;
}

.my-main-footer {
  width: 100%;
  background-color: #4f4f4f;
}

/* .my-main-content {
  min-height: calc(100vh - 90px);
  position: relative;
  padding-top: 60px;
  max-width: 1280px;
  margin-right: 8vw;
  margin-left: 8vw;
} */

/* @media screen and (min-width: 599px) {
  .my-main-content {
    min-height: calc(100vh - 108px);
    position: relative;
    padding-top: 60px;
    padding-bottom: 48px;
    max-width: 1280px;
    margin-right: 8vw;
    margin-left: 8vw;
  }
} */

/* @media screen and (max-width: 600px) {
  .my-main-content {
    min-height: calc(100vh - 108px);
    position: relative;
    padding-top: 60px;
    padding-bottom: 48px;
  }
} */

.my-main-content {
  max-height: calc(100vh - 108px);
  position: relative;
  padding-top: 60px;
  overflow-y: auto;
}

.my-main-content-web {
  min-height: calc(100vh - 108px);
  position: relative;
  padding-top: 60px;
  overflow-y: auto;
}

/* 列印 QRcode 用 */
@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}

.square-img {
  width: 100%;
  height: 0px;
  padding-bottom: 100%;
  position: relative;
}
.square-img img {
  width: 100%;
  height: 100%;
  position: absolute;
}

.square-div {
  width: 100%;
  height: 0px;
  padding-bottom: 100%;
  position: relative;
}
.square-div span {
  width: 100%;
  height: 100%;
  position: absolute;
}

.one-line-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.two-line-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.list-section {
  margin: 20px;
}

.list-section h1 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #4f4f4f;
  line-height: 1px;
  margin: 20px 0 14px;
  font-weight: bold;
  font-size: 26px;
}

.text3D {
  color: #ffffff;
  letter-spacing: 0;
  text-shadow: 2px 5px 0px #000;
}

.error {
  font-weight: bold;
  color: red;
}

.el-drawer {
  background-color: black !important;
  color: lightgray;
}
</style>
